import React, {Fragment} from 'react';
import { Formik, FieldArray } from 'formik';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Button, Form } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import Dialog from 'react-bootstrap-dialog';
import {affiliationType} from '../constants';
import {saveRtvChannels, deleteRtvChannel} from '../actions/admin';

const DEDICATED_PLAN_DISCOUNTS = {1: 0, 3: 5, 6: 10, 12: 20};
const DEDICATED_PLAN_MONTHS = Object.keys(DEDICATED_PLAN_DISCOUNTS).map(Number);

const defaultDedicatedPlanPrice = (monthlyPrice, months) => (
  Number(((Number(monthlyPrice || 0) * months * (100 - DEDICATED_PLAN_DISCOUNTS[months])) / 100).toFixed(2))
);

const withDedicatedPlans = rtvChannel => ({
  ...rtvChannel,
  dedicatedPlans: DEDICATED_PLAN_MONTHS.map(months => {
    const plan = (rtvChannel.dedicatedPlans || []).find(item => item.months === months);
    return plan || {
      months,
      price: defaultDedicatedPlanPrice(rtvChannel.rtvPrice, months),
      active: true,
      label: '',
      promotionEndsAt: '',
      autoRenew: true
    };
  })
});

export const AdimPartnerRtvChannels = ({partner, rtvChannels, saveRtvChannels, deleteRtvChannel}) => {
  const {t} = useTranslation();
  const rtvGroup = rtvChannelId => partner.affiliations.find(g => g.type === affiliationType.rtv && g.rtvChannelId === rtvChannelId && g.active === true);

  let dialog = null;

  const onRemoveRtvChannel = rtvChannel => {
    dialog.show({
      title: t('DELETE_RTV_CHANNEL', {name: rtvChannel.name}),
      body: t('CONFIRM_DELETE_RTV_CHANNEL'),
      actions: [
        Dialog.Action(
          t('DELETE'),
          () => deleteRtvChannel(rtvChannel.id),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('NO'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const rtvTypes = {
    replayerVideo: 0,
    partnerVideo: 1
  };

  return (    
      <Formik
        enableReinitialize
        initialValues={{rtvChannels: rtvChannels.map(withDedicatedPlans)}}
        onSubmit={saveRtvChannels}
      >
        {({
          handleSubmit,
          handleChange,
          setFieldValue,
          values
        }) => (
            <Form onSubmit={handleSubmit}>               
              <FieldArray name="rtvChannels">
                {({ insert, remove, push }) => (
                  <Fragment>
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={() => push(withDedicatedPlans({uid: partner.uid, name: '', rtvPrice: 0, rtvKeepVideos: 0, rtvPriceMembership: 0, rtvPriceEvent: 0, blocked: false, type: rtvTypes["replayerVideo"]}))}
                    >
                      {t("ADD_RTV_CHANNEL")}
                    </Button>
                    <Button
                      disabled={values.rtvChannels.filter(c => c.type === rtvTypes["partnerVideo"]).length > 0}
                      type="button"
                      style={{marginLeft: 10}}
                      variant="primary"
                      onClick={() => push({uid: partner.uid, name: '', rtvPrice: 0, rtvKeepVideos: 0, rtvPriceMembership: 0, rtvPriceEvent: 0, blocked: false, type: rtvTypes["partnerVideo"]})}
                    >
                      {t("ADD_RTV_CHANNEL_PARTNER_VIDEO")}
                    </Button>
                    <div className="row" style={{ minHeight: 400, marginTop: 20 }}>
                      {values.rtvChannels.length > 0 &&
                        values.rtvChannels.map((rtvChannel, index) => (                    
                            <div key={rtvChannel.id} className="col-md-12 col-lg-4 mb-sm-4 card-group">
                              <div className={rtvChannel.type === rtvTypes.partnerVideo ?  "card video_partner_card_bg_rp" : "card sportcenter_card_bg_rp"}>
                                <div className="card-body d-flex flex-column card_border_bottom_white mb-3">
                                  <Form.Group>
                                    <Form.Label>{t('NAME')}</Form.Label>
                                    <Form.Control required name={`rtvChannels.${index}.name`} placeholder={t('NAME')} type="text" maxLength={50} value={rtvChannel.name} onChange={handleChange}/>
                                  </Form.Group>
                                </div>
                                <div className="card-body d-flex flex-column card_border_bottom_white mb-3">
                                  <Form.Group>
                                    <Form.Label>{t('REPLAYER_TV_PRICE_DESC')}</Form.Label>
                                    <Form.Control
                                      name={`rtvChannels.${index}.rtvPrice`}
                                      placeholder={t('REPLAYER_TV_PRICE_DESC')}
                                      type="number"
                                      min={0}
                                      max={100}
                                      step={0.01}
                                      value={rtvChannel.rtvPrice}
                                      onChange={event => {
                                        handleChange(event);
                                        const monthlyPrice = Number(event.target.value || 0);
                                        rtvChannel.dedicatedPlans.forEach((plan, planIndex) => {
                                          setFieldValue(
                                            `rtvChannels.${index}.dedicatedPlans.${planIndex}.price`,
                                            defaultDedicatedPlanPrice(monthlyPrice, plan.months)
                                          );
                                        });
                                      }}
                                    />
                                  </Form.Group>
                                  <Form.Group>                                    
                                    <Form.Label>{t('REPLAYER_TV_PRICE_MEMBERSHIP')}</Form.Label>
                                    <Form.Control name={`rtvChannels.${index}.rtvPriceMembership`} placeholder={t('REPLAYER_TV_PRICE_MEMBERSHIP')} type="number" min={0} max={100} step={0.01} value={rtvChannel.rtvPriceMembership} onChange={handleChange}/>
                                    {
                                      rtvGroup(rtvChannel.id) ?
                                      <Form.Text className="text-muted color-green">{t('REPLAYER_TV_PRICE_MEMBERSHIP_ACTIVE')}</Form.Text>
                                      :                                        
                                        <Form.Text className="text-muted color-red">{t('REPLAYER_TV_PRICE_MEMBERSHIP_INACTIVE')}</Form.Text>
                                    }
                                  </Form.Group>
                                  <Form.Group>
                                    <Form.Check
                                      type="checkbox"
                                      name={`rtvChannels.${index}.blocked`}
                                      label={t("RTV_BLOCKED")}
                                      checked={rtvChannel.blocked}
                                      onChange={handleChange}/>
                                  </Form.Group>
                                  {rtvChannel.type === rtvTypes.replayerVideo && (
                                    <div className="card_border_top_white pt-3 mb-3">
                                      <h6>{t('DEDICATED_PAGE_PLANS')}</h6>
                                      <Form.Text className="text-muted d-block mb-3">
                                        {t('DEDICATED_PAGE_PLANS_DEFAULT_HELP')}
                                      </Form.Text>
                                      {rtvChannel.dedicatedPlans.map((plan, planIndex) => (
                                        <div key={plan.months} className="border rounded p-2 mb-2">
                                          <Form.Check
                                            type="checkbox"
                                            name={`rtvChannels.${index}.dedicatedPlans.${planIndex}.active`}
                                            label={t('MONTH_COUNT', {count: plan.months})}
                                            checked={plan.active}
                                            onChange={handleChange}
                                          />
                                          <Form.Group className="mb-2">
                                            <Form.Label>{t('TOTAL_PRICE_EUR')}</Form.Label>
                                            <Form.Control
                                              name={`rtvChannels.${index}.dedicatedPlans.${planIndex}.price`}
                                              type="number"
                                              min={0}
                                              step={0.01}
                                              value={plan.price}
                                              readOnly={plan.months === 1}
                                              onChange={handleChange}
                                            />
                                            <Form.Text className="text-muted">
                                              {plan.months === 1
                                                ? t('SAME_AS_REPLAYERTV_AMOUNT')
                                                : t('EFFECTIVE_DISCOUNT', {discount: Math.max(0, Math.round((1 - (Number(plan.price || 0) / (Number(rtvChannel.rtvPrice || 0) * plan.months || 1))) * 100))})}
                                            </Form.Text>
                                          </Form.Group>
                                          <Form.Group className="mb-2">
                                            <Form.Label>{t('PROMOTION_LABEL')}</Form.Label>
                                            <Form.Control
                                              name={`rtvChannels.${index}.dedicatedPlans.${planIndex}.label`}
                                              type="text"
                                              maxLength={80}
                                              value={plan.label || ''}
                                              onChange={handleChange}
                                            />
                                          </Form.Group>
                                          <Form.Group className="mb-2">
                                            <Form.Label>{t('PROMOTION_VALID_UNTIL')}</Form.Label>
                                            <Form.Control
                                              name={`rtvChannels.${index}.dedicatedPlans.${planIndex}.promotionEndsAt`}
                                              type="datetime-local"
                                              value={plan.promotionEndsAt ? plan.promotionEndsAt.slice(0, 16) : ''}
                                              onChange={handleChange}
                                            />
                                          </Form.Group>
                                          <Form.Check
                                            type="checkbox"
                                            name={`rtvChannels.${index}.dedicatedPlans.${planIndex}.autoRenew`}
                                            label="Rinnovo automatico"
                                            checked={plan.autoRenew}
                                            onChange={handleChange}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                  <div className="row" style={{ margin: 0 }}>
                                    <Button type="submit" style={{marginRight: 10}}>{t("SAVE")}</Button>
                                    {
                                      rtvChannel.id ?
                                        <Button
                                          type="button"
                                          variant="secondary"
                                          onClick={() => onRemoveRtvChannel(rtvChannel)}
                                        >
                                          {t('DELETE')}
                                        </Button> :
                                        <Button
                                          type="button"
                                          variant="secondary"
                                          onClick={() => remove(index)}
                                        >
                                          {t('DELETE')}
                                        </Button>
                                    }
                                  </div>
                                </div>                                
                              </div>
                            </div>
                        ))}
                    </div>
                  </Fragment>
                )}
              </FieldArray>
              <Dialog
              ref={el => {
                dialog = el;
              }}/>
            </Form>
        )}
      </Formik>
    
  )
};

AdimPartnerRtvChannels.propTypes = {
  partner: PropTypes.object,
  token: PropTypes.string,
  rtvChannels: PropTypes.array,
  saveRtvChannels: PropTypes.func.isRequired,
  deleteRtvChannel: PropTypes.func.isRequired,
};

AdimPartnerRtvChannels.defaultProps = {
  partner: null,
  token: null,
  rtvChannels: [],
};

const mapStateToProps = ({login: {token}, admin: {selectedPartner, selectedPartnerRtvChannels}}) => ({
  token,
  partner: selectedPartner,  
  rtvChannels: selectedPartnerRtvChannels
});

const mapDispatchToProps = dispatch => ({
  saveRtvChannels: values => {
    dispatch(saveRtvChannels(values.rtvChannels));
  },
  deleteRtvChannel: rtvChannelId => {
    dispatch(deleteRtvChannel(rtvChannelId));
  }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdimPartnerRtvChannels));
